// @flow
import React, { Component } from 'react';
import _ from 'lodash';
import { Grid } from 'semantic-grab-ui/src';
import type { Country } from 'types/country';
import type { TridentCampaignDetails } from 'types/trident-campaigns';
import StatusLabel from 'components/custom/StatusLabel';

type Props = {
  campaign: TridentCampaignDetails,
  countries: Array<Country>,
}

// CampaignOverviewReview shows basic info of a campaign
export default class CampaignOverviewReview extends Component {
  props: Props;

  getCountry = () => {
    const country = _.find(this.props.countries, c => {
      return c.countryID === Number(_.get(this.props.campaign, 'countryID'));
    });
    return country ? country.name : '';
  };

  render() {
    let startTimeStr = '';
    let endTimeStr = '';
    const startTime = _.get(this.props.campaign, 'startTime');
    if (startTime) {
      startTimeStr = startTime.format('MMM Do YYYY, h:mm:ss a');
    }
    const endTime = _.get(this.props.campaign, 'endTime');
    if (endTime) {
      endTimeStr = endTime.format('MMM Do YYYY, h:mm:ss a');
    }
    let objective = _.get(this.props.campaign, 'objective');
    if (_.isEmpty(objective)) {
      objective = 'Not Specified';
    }

    const tableData = [
      {
        Country: this.getCountry(),
        'Target User Type': _.get(this.props.campaign, 'targetUserType', '???'),
        Timezone: _.get(this.props.campaign, 'timezone', '???'),
      },
      {
        'Start Time': startTimeStr,
        'End Time': endTimeStr,
        Objective: objective,
      },
      {
        Owner: _.get(this.props.campaign, 'owner', '???'),
        'Owner Reference ID': _.get(this.props.campaign, 'ownerReferenceID', '???'),
        Status: <StatusLabel status={_.get(this.props.campaign, 'status', '???')} />,
      },
    ];

    return (
      <Grid>
        {tableData.map(rowData => (
          <Grid.Row columns="equal">
            {_.map(rowData, (data, dataKey) => (
              <React.Fragment key={dataKey}>
                <Grid.Column>
                  <b>{dataKey}:</b>
                </Grid.Column>
                <Grid.Column>
                  {data}
                </Grid.Column>
              </React.Fragment>
            ))}
          </Grid.Row>
        ))}
      </Grid>
    );
  }
}
